module.exports = __webpack_public_path__ + "static/media/04eumc.60f9bc03.png";